import _typeof from "@babel/runtime/helpers/esm/typeof";
// import { isServer } from './util_00_env';
import { getCookie } from './util_03_cookie';
var isClient = (typeof window === "undefined" ? "undefined" : _typeof(window)) === 'object' && window && typeof document !== 'undefined'; // 获取ua

var UA = !isClient ? '' : navigator.userAgent.toLowerCase() || '';
/**
 * 是否为微信环境
 * @memberof module:User-Agent
 */

var isWeixin = UA.indexOf('micromessenger') !== -1;
/**
 * 是否为微博环境
 * @memberof module:User-Agent
 */

var isWeiBo = UA.indexOf('weibo') !== -1;
/**
 * 是否为QQ浏览器环境
 * @memberof module:User-Agent
 */

var isQQ = UA.indexOf('mqqbrowser') !== -1;
/**
 * 是否手机登陆
 * @constant
 * @memberof module:User-Agent
 */

function checkPhoneLogin() {
  return parseInt(getCookie('uid_type'), 10) === 1002 || parseInt(getCookie('uid_type'), 10) === 20000;
}

var isPhoneLogin = checkPhoneLogin();
/**
 * 是否weixin登陆
 * @constant
 * @memberof module:User-Agent
 */

function checkIsWXLogin() {
  return parseInt(getCookie('uid_type'), 10) === 2 || checkPhoneLogin() && parseInt(getCookie('uid_origin_uid_type'), 10) === 2;
}

var isWXLogin = checkIsWXLogin();
/**
 * 是否QQ登陆
 * @constant
 * @memberof module:User-Agent
 */

function checkQQLogin() {
  return (getCookie('p_skey') !== '' || getCookie('skey') !== '') && !checkIsWXLogin() && !checkPhoneLogin();
}

var isQQLogin = checkQQLogin();
/**
 * 获取qq uin
 * @memberof module:User-Agent
 * @return {string | number} 返回QQ的uin
 */

function getQQUin() {
  var uin = getCookie('p_luin') || getCookie('luin') || getCookie('p_uin') || getCookie('uin');
  var realUin = uin.length > 14 ? uin : parseInt(uin.replace(/[^\d]/g, ''), 10);
  return !realUin ? '' : realUin;
}
/**
 * 获取用户 uin，兼容微信和QQ
 * @memberof module:User-Agent
 * @return {string | number} 返回QQ或者微信的uin
 */


function getUin() {
  return !checkQQLogin() ? getCookie('uid_uin') || getQQUin() : getQQUin();
}
/**
 * 获取登录态字段
 * @memberof module:User-Agent
 * @return {string}  返回登录态字段
 */


function getAuth() {
  return !checkQQLogin() ? getCookie('uid_a2') || getSkey() : getSkey();
}
/**
 * 优先使用p_skey
 * @memberof module:User-Agent
 * @return {string}  返回p_skey
 */


function getSkey() {
  return getCookie('p_skey') || getCookie('skey');
}

function encryptSkey(str) {
  if (!str) {
    return '';
  }

  var hash = 5381;

  for (var i = 0, len = str.length; i < len; ++i) {
    hash += (hash << 5) + str.charAt(i).charCodeAt(); // jshint ignore:line
  }

  return hash & 0x7fffffff;
}
/**
 * 获取 bkn
 * @memberof module:User-Agent
 * @return {string} - get encryped auth info from cookie
 */


function getBkn() {
  return encryptSkey(getAuth());
}
/**
 * 生成随机 id
 * @param {number} [len=10] 随机ID的长度，最小值2，最大值10
 * @memberof module:User-Agent
 * @return {string} 返回随机字符串
 */


function createRandomId() {
  var len = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 10;
  return Math.random().toString(35).substr(2, 10).substr(0, len);
}
/**
 * 是否是PC环境
 * @memberof module:User-Agent
 * @return {bool} 是否是PC环境
 */


function isPC() {
  return !/(iPhone|iPad|iPod|iOS|Android)/i.test(navigator.userAgent);
}
/**
 * @memberof module:User-Agent
 * @return {bool}
 * @TODO 删除这个方法
 * @ignore
 */


function isWX() {
  return isWeixin;
}
/**
 * 目前只有在微信，safari，uc，手Q中可以调起微信登录，否则只能调起QQ登录
 * @memberof module:User-Agent
 * @return {bool}
 */


function isSupportWXLogin() {
  return / micromessenger\//i.test(UA) && !/ wxwork\//i.test(UA) || // 微信 且不是 企业微信
  /(iphone)+[\S|\s]*(version\/)[\S|\s]*safari\//i.test(UA) || / mqqbrowser\//i.test(UA) && !/ qq\/\d/i.test(UA) // 手Q可以调起微信，但微信授权完毕后跳不回手Q了，所以先屏蔽手Q调起微信登录的功能
  || /(iphone)+[\S|\s]*uc/i.test(UA) || /(android)+[\S|\s]*uc/i.test(UA);
}
/**
 * 是否是MQQ
 * @memberof module:User-Agent
 * @return {bool} 是否是MQQ
 */


function isMQQ() {
  return /qq\/(\d+\.\d+)/i.test(navigator.userAgent.toLowerCase());
}

var REGEXP_FUDAO_APP = /EducationApp/;
var REGEXP_K12_APP = /k12student/;
/**
 * 是否是辅导的APP
 * @memberof module:User-Agent
 * @return {bool} 是否是辅导APP
 */

function isFudaoApp() {
  if (!isClient) {
    return false;
  }

  var version = getBigVersionNumber();

  if (!version || version >= 4 && !REGEXP_K12_APP.test(navigator.userAgent)) {
    return false;
  }

  return REGEXP_FUDAO_APP.test(navigator.userAgent);
}

var BIG_VERSION_NUMBER_REG = /EducationApp\/([\d]+)/;
/**
 * 版本号判断，主要用来区分课堂还是辅导，版本号大于4均为课堂app
 * @return {bool} 是否是辅导APP
 */

function getBigVersionNumber() {
  if (!window) {
    return 0;
  }

  var res = BIG_VERSION_NUMBER_REG.exec(navigator.userAgent);

  if (res) {
    return parseInt(res[1], 10);
  }

  return 0;
}
/**
 * 判断 version code 是不是 0
 * @memberof module:User-Agent
 * @return {bool}
 */


function versionCodeZero() {
  return /VersionCode\/0/.test(navigator.userAgent);
}
/**
 * 获取当前辅导APP的版本
 * @memberof module:User-Agent
 * @returns {number | string} 如果不是在辅导APP的环境下就返回0，否则返回版本号
 */


function getAppVersion() {
  if (!isFudaoApp()) {
    return 0;
  }

  var version = (/VersionCode\/(\d+)/.exec(navigator.userAgent) || [])[1];
  return version || 0;
}
/**
 * 获取当前环境如：IOS、Android、H5
 * @memberof module:User-Agent
 * @return {string} ios/android/h5
 */


function getPlatForm() {
  if (isFudaoApp()) {
    if (/iPhone|iPad|iPod|iOS/i.test(navigator.userAgent)) {
      return 'ios';
    }

    if (/Android/i.test(navigator.userAgent)) {
      return 'android';
    }
  } else if (/win|macintel/i.test(navigator.platform)) {
    return navigator.platform;
  } else {
    return 'h5';
  }
}
/**
 * 获取在哪个环境下的H5
 * @memberof module:User-Agent
 * @return {string} ios_h5/android_h5/pc_h5/h5
 */


function getTerminal() {
  if (isFudaoApp()) {
    if (/iPhone|iPad|iPod|iOS/i.test(navigator.userAgent)) {
      return 'ios_h5';
    }

    if (/Android/i.test(navigator.userAgent)) {
      return 'android_h5';
    }
  } else if (/win|macintel/i.test(navigator.platform)) {
    return 'pc_h5';
  } else {
    return 'h5';
  }
}
/**
 * 判断是不是h5环境且设备是ipad
 * @memberof module:User-Agent
 * @returns {Boolean}
 */


function isIpadH5() {
  if (isFudaoApp() && /iPad/i.test(navigator.userAgent)) {
    return true;
  }

  return false;
}
/**
 * 获取当前平台的code代码
 * @memberof module:User-Agent
 * @return {number} 1、2、3
 */


function getPlatformCode() {
  if (/iPhone|iPad|iPod|iOS/i.test(navigator.userAgent)) {
    return 1;
  }

  if (/Android/i.test(navigator.userAgent)) {
    return 2;
  }

  return 3;
}
/**
 * 获取IOS的版本
 * @memberof module:User-Agent
 * @returns {bool | string} 返回当前IOS的版本号，如果不是IOS则返回false
 */


function getIOSVersion() {
  var _navigator = navigator,
      _navigator$userAgent = _navigator.userAgent,
      userAgent = _navigator$userAgent === void 0 ? '' : _navigator$userAgent;

  if (userAgent.indexOf('iPhone') === -1 && userAgent.indexOf('iPad') === -1 && userAgent.indexOf('iPod') === -1) {
    return false;
  }

  var i = userAgent.indexOf(' OS ') + 4;
  return userAgent.substring(i, userAgent.indexOf(' ', i)).replace(/_/g, '.');
}
/**
 * helper for getTencentURL
 * @param {string} k
 * @ignore
 * @returns {string}
 */


function encodeParam(k) {
  k += '';
  var f = [];

  for (var i = 0; i < k.length; i++) {
    f.push(k.charCodeAt(i).toString(16).toUpperCase());
  }

  return f.join('');
}
/**
 *  helper for getTencentURL
 * @param {string} h
 * @param {string} g
 * @param {string} k
 * @param {string} fuin
 * @returns {string}
 * @ignore
 */


function getURL(h, g, k, fuin) {
  if (!h) {
    return '';
  }

  return "tencent://".concat(h, "/?subcmd=").concat(g, "&param=").concat(k).concat(fuin ? "&fuin=".concat(fuin) : '');
}
/**
 *  helper for getTencentURL
 * @param {string} h
 * @param {string} g
 * @param {string} k
 * @param {string} fuin
 * @returns {string}
 * @ignore
 */


function getEncodedURL(h, g, k, fuin) {
  if (!h) {
    return '';
  }

  k = encodeParam(k);
  return getURL(h, g, k, fuin);
}
/**
 * @memberof module:tencent/imutils
 * @description 获取tencent串
 * @param {string} type
 * @param {object} obj
 * @param {string} obj.gc
 * @param {string} obj.guin
 * @param {string} obj.appId
 * @param {string} obj.courseId
 * @return {string}
 * @TODO 看着晕，重构
 */


function getTencentURL(type, obj) {
  var h, g, k;
  var t;

  switch (type) {
    case 'all':
      // 'all'+gc: 打开群  限制:公开群不在群内, 无法直接打开aio, 而是会弹加群窗口
      h = 'groupwpa';
      g = 'all';
      k = "{\"groupUin\":".concat(obj.gc, ", \"timeStamp\":1383552440}");
      break;

    case 'OpenGroup':
      // appid 0 打开公开群  限制:非公开群不再群内不会弹加群窗口,而是会弹"群主已将此群设置为非公开，加群后才能继续访问."
      h = 'groupwpa';
      g = 'OpenGroup';
      var appid = obj.appId || 0;
      k = "{\"ExtParam\":{\"appId\":".concat(appid, "},\"groupUin\":").concat(obj.guin, ",\"visitor\":1}");
      break;

    case 'VisitPublicGroup':
      // 5.1以上才支持  限制:几乎无限制, 公开群/非公开群都表现正常(非公开群不在群内打开加群窗口,其他情况都能打开)
      h = 'VisitPublicGroup';
      g = 'VisitPublicGroup';
      k = "{\"ExtParam\":{\"appId\":\"0\"},\"groupUin\":".concat(obj.gc, ",\"visitor\":1}"); // k = '{"ExtParam":{"appId":""},"groupUin":' + obj.gc + ',"groupuin":'+ obj.gc +',"visitor":1}';

      break;

    case 'CourseLive':
      // 5.2以上才支持??
      h = 'VisitPublicGroup';
      g = 'VisitPublicGroupEx';
      k = "{\"ExtParam\":{\"appId\":\"21\",\"appParam\":\"{\\\"CourseId\\\":".concat(obj.courseId, "}\"},\"groupUin\":").concat(obj.gc, ",\"visitor\":1}");
      break;
  }

  if (h) {
    var fuin = getCookie('uin') || void 0;
    return getEncodedURL(h, g, k, fuin);
  }

  return '';
}
/**
 * 获取IE版本号
 * @memberof module:tencent/imutils
 * @see https://codepen.io/gapcode/pen/vEJNZN
 * @returns {bool | number} 如果是IE就返回IE的版本号，否则返回false
 */


function getIEVer() {
  var ua = window.navigator.userAgent;
  var msie = ua.indexOf('MSIE ');

  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');

  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');

  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  } // other browser


  return false;
}
/**
 * 获取safari版本号
 * @memberof module:tencent/imutils
 * @returns {bool | boolean} 如果是safari就返回safari的版本号，否则返回false
 */


function getSafariVer() {
  var matchVer = navigator.userAgent.match(/Version\/([\d\.]+).*Safari/);

  if (matchVer) {
    return parseInt(matchVer[1], 10);
  }

  return false;
}
/**
 * 获取Firefox版本号
 * @memberof module:tencent/imutils
 * @returns {bool | string} 如果是Firefox就返回Firefox的版本号，否则返回false
 */


function getFirefoxVer() {
  var matchVer = navigator.userAgent.match(/Firefox\/([0-9]+)\./);

  if (matchVer) {
    return parseInt(matchVer[1], 10);
  }

  return false;
}
/**
 * 获取老师端的版本号
 * @memberof module:tencent/imutils
 * @return {number | string} 版本号
 */


function getTeacherClient() {
  var version = (/TXK12\/(\d+)/.exec(navigator.userAgent) || [])[1];
  return version || 0;
}
/**
 * 获取学生端的版本号
 * @return {string} 版本号
 */


function getStudentClientVersion() {
  var version = (/TXK12ForStu\/(\d+)/.exec(navigator.userAgent) || [])[1];
  return version || '';
}
/**
 * 获取是否PC老师或学生客户端
 * @memberof module:tencent/imutils
 * @return {boolean} true: 是，false: 否
 */


function isFudaoClient() {
  return !!getTeacherClient() || !!getStudentClientVersion();
}
/**
 * 检测是否是iPhone X
 * @memberof module:tencent/imutils
 * @return {bool} 是否是iPhone X
 */


function isIphoneX() {
  // iPhone X、iPhone XS
  var isIPhoneX = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 375 && window.screen.height === 812; // iPhone XS Max iphone11 Pro

  var isIPhoneXSMax = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 3 && window.screen.width === 414 && window.screen.height === 896; // iPhone XR iphone11

  var isIPhoneXR = /iphone/gi.test(window.navigator.userAgent) && window.devicePixelRatio && window.devicePixelRatio === 2 && window.screen.width === 414 && window.screen.height === 896;

  if (isIPhoneX || isIPhoneXSMax || isIPhoneXR) {
    return true;
  }

  return false;
}
/**
 * 微信小程序环境
 */


var isWeixinMinProgram = typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram';
/**
 * 对比两个版本号
 */

function compareVersion(a, b) {
  var l;
  var r;

  var _a = String(a).split('.');

  var _b = String(b).split('.');

  for (var i = 0, len = Math.max(_a.length, _b.length); i < len; i++) {
    l = Number(_a[i]) || 0;
    r = Number(_b[i]) || 0;

    if (l < r) {
      return -1;
    }

    if (l > r) {
      return 1;
    }
  }

  return 0;
}
/**
 * 获取是否为mac客户端
 * @memberof module:tencent/imutils
 * @return {boolean} true: 是，false: 否
 */


function isMacClient() {
  if (!window) {
    return false;
  }

  return /K12Mac/.test(navigator.userAgent);
}

export { createRandomId, getUin, getQQUin, getSkey, getAuth, getBkn, isWeixin, isWeiBo, isPC, isWX, isQQ, isQQLogin, isWXLogin, isPhoneLogin, isWeixinMinProgram, isSupportWXLogin, isMQQ, isFudaoApp, isIpadH5, versionCodeZero, getPlatForm, getTerminal, getAppVersion, getPlatformCode, getIOSVersion, getTencentURL, getIEVer, getSafariVer, getFirefoxVer, getTeacherClient, getStudentClientVersion, isIphoneX, isFudaoClient, checkPhoneLogin, compareVersion, isMacClient };